/**
 * Importe automatiquement les fichiers de traduction trouvés sous l'arborescence i18n
 */
import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

function loadLocaleMessages() {
  const listlocale = require.context('../i18n', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const tabMessage = {};
  listlocale.keys().forEach((insKey) => {
    const tabMatched = insKey.match(/([A-Za-z0-9-_]+)\./i);
    if (tabMatched && tabMatched.length > 1) {
      tabMessage[tabMatched[1]] = listlocale(insKey);
    } else {
      Vue.$log.info(`fichier langue exclu : ${tabMatched[1]}`);
    }
  });
  return tabMessage;
}

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages(),
});

export default i18n;
